import React, { Fragment } from "react";
import { BellOutlined } from "@ant-design/icons";
import { withRouter, Link } from "react-router-dom";
import { Avatar, Badge, Menu, Popover } from "antd";
import { Auth } from "_helpers";

const SubMenu = Menu.SubMenu;

const notificationContent = (
  <div style={{ width: 250 }}>
    <p>You have 2 new approvals pending.</p>
    <p>Material stock updated successfully.</p>
    <Link to="/notifications">View all notifications</Link>
  </div>
);

const AppHeader = withRouter(({ history }) => (
  <Menu
    key="key"
    mode="horizontal"
    defaultSelectedKeys={["1"]}
    defaultOpenKeys={["sub1"]}
    theme="dark"
    style={{ width: 300, height: 62, display: "flex", justifyContent: "flex-end", alignItems: "center" }}
  >
    {/* <SubMenu
      title={
        <Fragment>
          <span style={{ color: "#999", marginRight: 4 }}>
            {Auth.getTitle()}:
          </span>
          <Avatar shape="circle" size="default" />
        </Fragment>
      }
    >
      <Menu.Item key="profile">
        <Link to="/account">
          <span>Profile</span>
        </Link>
      </Menu.Item>
      <Menu.Item
        key="SignOut"
        onClick={() => {
          Auth.clearSession();
          history.push("/");
        }}
      >
        <span>Sign out</span>
      </Menu.Item>
    </SubMenu> */}
    <div style={{ display: "flex", alignItems: "center", gap: "16px", marginRight: "12px" }}>
      {/* 🔔 Notification Bell */}
      <Popover
        placement="bottomRight"
        content={notificationContent}
        trigger="click"
      >
        <Badge count={3} size="small">
          <BellOutlined style={{ fontSize: 18, color: "#fff", cursor: "pointer" }} />
        </Badge>
      </Popover>

      {/* 👤 User Info */}
      <SubMenu
        title={
          <Fragment>
            <span style={{ color: "#999", marginRight: 6 }}>
              {Auth.getTitle()}:
            </span>
            <Avatar
              shape="circle"
              size="default"
              src="/img/avatar.png" // replace with your own image
              alt="User Avatar"
            />
          </Fragment>
        }
      >
        <Menu.Item key="profile">
          <Link to="/account">
            <span>Profile</span>
          </Link>
        </Menu.Item>
        <Menu.Item
          key="SignOut"
          onClick={() => {
            Auth.clearSession();
            history.push("/");
          }}
        >
          <span>Sign out</span>
        </Menu.Item>
      </SubMenu>
    </div>
  </Menu>
));

export default AppHeader;
